import { render, staticRenderFns } from "./Changelogin.vue?vue&type=template&id=502a98a5&"
import script from "./Changelogin.vue?vue&type=script&lang=js&"
export * from "./Changelogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports